import React from "react";
import Pagination from "@mui/material/Pagination";

import prev from "../assets/prev.png";
import next from "../assets/next.png";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { SiTicktick } from "react-icons/si";
import { MdCancel } from "react-icons/md";
import { FaUserGroup } from "react-icons/fa6";
import { CiHospital1 } from "react-icons/ci";

const Page = ({
  paginationPage,
  nextPage,
  previousPage,
  canPreviousPage,
  canNextPage,
  pageOptions,
  onPageChange,
  screen,
}) => {
  const numericPaginationPage = Number(paginationPage);

  const isFirstPage = numericPaginationPage === 0;
  const isLastPage = numericPaginationPage === pageOptions.length - 1;

  return (
    <div className="flex justify-between items-center px-4">
      <Pagination
        count={pageOptions.length}
        page={numericPaginationPage + 1}
        color="primary"
        size="small"
        classes={{
          ul: "flex justify-center",
          li: "flex items-center",
          selected: "bg-indigo-600 text-white",
        }}
        hideNextButton
        hidePrevButton
        sx={{
          "& .MuiPaginationItem-root": {
            color: "gray",
            cursor: "default",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor: "#4951ec",
            color: "#fff",
            cursor: "default",
          },
          "& .MuiPaginationItem-ellipsis": {
            color: "#9E9E9E",
            cursor: "default",
          },
        }}
      />

      {screen === "userList" && (
        <div className="flex flex-row justify-between gap-3 bg-gray-100 p-1 rounded-lg px-2">
          <div className="flex items-center">
            <SiTicktick color={"#00AA44"} size={14} />
            <span className="ml-2 text-[12px]">Verified</span>
          </div>

          <div className="flex items-center">
            <AiOutlineExclamationCircle color={"orange"} size={14} />
            <span className="ml-2 text-[12px]">Pending</span>
          </div>

          <div className="flex items-center">
            <MdCancel color={"#FF0000"} size={14} />
            <span className="ml-2 text-[12px]">Rejected</span>
          </div>

          <div className="flex items-center">
            <FaUserGroup color={"#b042f5"} size={13} />
            <span className="ml-2 text-[12px]">Account Holder</span>
          </div>

          <div className="flex items-center">
            <CiHospital1 color={"blue"} size={14} />
            <span className="ml-2 text-[12px]">User From Partner</span>
          </div>
        </div>
      )}

      <div className="flex items-center space-x-4">
        {/* Previous Button */}
        <button
          onClick={previousPage}
          disabled={isFirstPage} // Disable if it's the first page
          className={`text-blue-600 bg-white flex items-center cursor-pointer ${isFirstPage ? "opacity-50" : ""
            } ${screen === "hospital" ? "font-poppins" : ""}`}
        >
          <img src={prev} className="h-4 w-4 mt-1" alt="Previous" />
          <p className="text-sm ml-1">Previous</p>
        </button>

        {/* Next Button */}
        <button
          onClick={nextPage}
          disabled={isLastPage} // Disable if it's the last page
          className={`text-blue-600 bg-white flex items-center cursor-pointer ${isLastPage ? "opacity-50" : ""
            } ${screen === "hospital" ? "font-poppins" : ""}`}
        >
          <p className="text-sm mr-1">Next</p>
          <img src={next} className="h-4 w-4 mt-1" alt="Next" />
        </button>
      </div>
    </div>
  );
};

export default Page;
